import { List } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';

import BackstageAbout from '../../BackstageAbout';
import BackstageFeaturedContent from '../../BackstageFeaturedContent';
import CuratedPlaylists from '../../common/CuratedPlaylists';
import CuratedStations from '../../common/CuratedStations';
import ArtistEvents from '../BackstageArtist1/ArtistEvents';
import ArtistRadioGridItem from '../BackstageArtist1/ArtistRadioGridItem';
import ArtistSplitPane from '../BackstageArtist1/ArtistSplitPane';

import ArtistLatestReleaseGridItem from './ArtistLatestReleaseGridItem';
import ArtistSimilarArtists from './ArtistSimilarArtists';
import ArtistTopAlbums from './ArtistTopAlbums';
import ArtistTopSongs from './ArtistTopSongs';

// @ts-expect-error TS(7006) FIXME: Parameter 'props' implicitly has an 'any' type.
export const ArtistMainContent = props => {
  const {
    aboutBackgroundImageUrl,
    albumCount,
    artistPlayId,
    artistName,
    bio,
    curatedPlaylists,
    curatedStations,
    featuredContent,
    hasArtistEvents,
    hasLargeHeader,
    hasRadio,
    isMegastar,
    isMobileWeb,
    isRightRailActive,
    latestRelease,
    pandoraId,
    shareableUrlPath,
    similarArtists,
    topAlbums,
    topTracks,
    twitterUrl,
  } = props;

  const hasFeaturedContent = featuredContent?.length > 0;
  const featuredContentIdList = List(
    // @ts-expect-error TS(7006) FIXME: Parameter 'featuredContentItem' implicitly has an ... Remove this comment to see the full error message
    featuredContent?.map(featuredContentItem => featuredContentItem.pandoraId),
  );

  const LatestRelease = latestRelease && (
    <ArtistLatestReleaseGridItem
      artistPandoraId={pandoraId}
      isFirstSection={!hasLargeHeader && !hasFeaturedContent && !hasArtistEvents}
      isRightRailActive={isRightRailActive}
      latestRelease={latestRelease}
    />
  );

  const ArtistRadio = hasRadio && (
    <ArtistRadioGridItem
      hasRadio={hasRadio}
      isFirstSection={!hasLargeHeader && !hasFeaturedContent && !hasArtistEvents}
      isMobileDevice={isMobileWeb}
      isRightRailActive={isRightRailActive}
      pandoraId={pandoraId}
      shareableUrlPath={shareableUrlPath}
    />
  );

  return (
    <React.Fragment>
      {hasFeaturedContent && (
        <BackstageFeaturedContent
          featuredContentIds={featuredContentIdList}
          isFirstSection={!isMegastar}
        />
      )}
      {hasArtistEvents && (
        <ArtistEvents
          isFirstSection={!hasLargeHeader && !hasFeaturedContent}
          pandoraId={pandoraId}
        />
      )}
      <ArtistSplitPane left={LatestRelease} right={ArtistRadio} />
      {topTracks?.length > 0 && (
        <ArtistTopSongs
          // @ts-expect-error TS(2322) FIXME: Type '{ artistPlayId: any; topTracks: any; isMobil... Remove this comment to see the full error message
          artistPlayId={artistPlayId}
          topTracks={topTracks}
          isMobileWeb={isMobileWeb}
          shareableUrlPath={shareableUrlPath}
        />
      )}
      {topAlbums?.length > 0 && (
        <ArtistTopAlbums
          topAlbums={topAlbums}
          shareableUrlPath={shareableUrlPath}
          albumCount={albumCount}
          artistPandoraId={pandoraId}
          isMobileDevice={isMobileWeb}
          isRightRailActive={isRightRailActive}
        />
      )}
      {curatedStations?.length > 0 && (
        <CuratedStations
          stations={curatedStations}
          name={artistName}
          pandoraId={pandoraId}
          numberStations={curatedStations.length}
          shareableUrlPath={shareableUrlPath}
        />
      )}
      {curatedPlaylists?.length > 0 && (
        <CuratedPlaylists
          name={artistName}
          numberPlaylists={curatedPlaylists.length}
          playlists={curatedPlaylists}
          pandoraId={pandoraId}
          shareableUrlPath={shareableUrlPath}
        />
      )}
      {bio && (
        <BackstageAbout
          backgroundImgUrl={!isMegastar && aboutBackgroundImageUrl}
          bio={bio}
          pandoraId={pandoraId}
          shareableUrlPath={shareableUrlPath}
          socialLinks={{ twitterUrl }}
        />
      )}
      <ArtistSimilarArtists similarArtists={similarArtists} />
    </React.Fragment>
  );
};

ArtistMainContent.propTypes = {
  aboutBackgroundImageUrl: PropTypes.string,
  albumCount: PropTypes.number,
  artistName: PropTypes.string,
  artistPlayId: PropTypes.string,
  bio: PropTypes.string,
  curatedPlaylists: PropTypes.array,
  curatedStations: PropTypes.array,
  featuredContent: PropTypes.array,
  hasArtistEvents: PropTypes.bool,
  hasLargeHeader: PropTypes.bool,
  hasRadio: PropTypes.bool,
  isMegastar: PropTypes.bool,
  isMobileWeb: PropTypes.bool,
  isRightRailActive: PropTypes.bool,
  latestRelease: PropTypes.object,
  pandoraId: PropTypes.string,
  shareableUrlPath: PropTypes.string,
  similarArtists: PropTypes.array,
  topAlbums: PropTypes.array,
  topTracks: PropTypes.array,
  twitterUrl: PropTypes.string,
};

export default ArtistMainContent;
